import { ZodFormattedError, z } from 'zod';

export const clientSchema = z.object({
  VITE_BASE_API_URL: z.string().min(1),
  VITE_APP_BASE_URL: z.string().min(1),
  VITE_APP_NAME: z.string().min(1),
  VITE_DEPLOYMENT_ENV: z.string().min(1),
  VITE_REDIRECT_SUCCESS: z.string().min(1),
  VITE_REDIRECT_FAILURE: z.string().min(1),
  VITE_REDIRECT_CANCEL: z.string().min(1),
  VITE_APPLICATIONINSIGHTS_CONNECTION_STRING: z.string().optional(),
  VITE_VERSION: z.string().min(1),
  VITE_AZURE_CLIENT_ID: z.string().min(1),
  VITE_AZURE_AUTHORITY: z.string().min(1),
  VITE_AZURE_API_CLIENT_ID: z.string().min(1),
});

const _clientEnv = clientSchema.safeParse(import.meta.env);

export const formatErrors = (
  errors: ZodFormattedError<Map<string, string>, string>,
) =>
  Object.entries(errors).flatMap(([name, value]) =>
    value && '_errors' in value
      ? [`${name}: ${value._errors.join(', ')}\n`]
      : [],
  );

if (!_clientEnv.success) {
  console.error(
    '❌ Invalid environment variables:\n',
    ...formatErrors(_clientEnv.error.format()),
  );
  throw new Error('Invalid environment variables');
}

export const env = _clientEnv.data;
